import React, { useState } from 'react';
import './FAQ.css';

const FAQ = () => {
  const [activeCategory, setActiveCategory] = useState('general');
  const [expandedItems, setExpandedItems] = useState({});

  const toggleItem = (id) => {
    setExpandedItems(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  const categories = {
    general: {
      icon: '🌟',
      label: 'General',
      faqs: [
        {
          id: 'g1',
          question: 'What is Popperverse?',
          answer: 'Popperverse is a community-driven plushie brand built on Solana. Create unique designs with AI, vote for your favorites, and earn royalties when your design becomes a product!'
        },
        {
          id: 'g2',
          question: 'What is POPPERS token?',
          answer: 'POPPERS is our community token. When you vote on designs, a portion of your SOL is converted to POPPERS for on-chain vote tallying. This ensures transparent, verifiable voting.'
        },
        {
          id: 'g3',
          question: 'What wallet should I use?',
          answer: 'We recommend Solflare wallet for the best experience. Phantom, Backpack, and other Solana wallets are also supported.'
        }
      ]
    },
    shopping: {
      icon: '🛒',
      label: 'Shopping',
      faqs: [
        {
          id: 's1',
          question: 'How do I purchase a plushie?',
          answer: 'Connect your wallet, browse our Shop, select your plushie and quantity, then complete checkout with SOL. Each purchase includes a physical plushie and commemorative NFT!'
        },
        {
          id: 's2',
          question: 'What payment methods do you accept?',
          answer: 'We accept SOL (Solana) cryptocurrency. A portion of each sale goes to the design creator as royalties, plus allocations to POPCAT and POPPERS tokens.'
        },
        {
          id: 's3',
          question: 'How long does shipping take?',
          answer: 'Shipping typically takes 7-14 business days depending on your location. International orders may take longer. You\'ll receive tracking information via email.'
        },
        {
          id: 's4',
          question: 'Do I get an NFT with my purchase?',
          answer: 'Yes! Each plushie purchase comes with a commemorative NFT minted to your wallet, proving ownership and supporting the community ecosystem.'
        }
      ]
    },
    voting: {
      icon: '🗳️',
      label: 'Voting',
      faqs: [
        {
          id: 'v1',
          question: 'How does voting work?',
          answer: 'Vote by spending SOL on your favorite designs. When POPPERS swap is enabled, 50% of your vote converts to POPPERS tokens for on-chain tallying. The design with the most POPPERS votes wins!'
        },
        {
          id: 'v2',
          question: 'Can I vote multiple times?',
          answer: 'Absolutely! Vote as many times as you want, for any design. Each vote adds to the design\'s total. There\'s no minimum - vote with any amount of SOL.'
        },
        {
          id: 'v3',
          question: 'When does voting end?',
          answer: 'Voting rounds last 6 months. A countdown timer on the Vote page shows time remaining. Winners are announced after each round ends.'
        },
        {
          id: 'v4',
          question: 'What happens to losing designs?',
          answer: 'Losing designs are archived after a winner is declared. The NFTs remain in creators\' wallets and can be traded on the NFPOP Marketplace.'
        }
      ]
    },
    creating: {
      icon: '🎨',
      label: 'Creating',
      faqs: [
        {
          id: 'c1',
          question: 'How do I create a design?',
          answer: 'Go to the Create page, describe your plushie idea, and our AI generates it! Pay a small fee in SOL to mint it as an NFT and submit it for community voting.'
        },
        {
          id: 'c2',
          question: 'What happens if my design wins?',
          answer: 'Winning designs become official products! As the NFT holder, you receive 5% royalties on every sale of that plushie. Trade or hold your NFT - whoever owns it gets the royalties.'
        },
        {
          id: 'c3',
          question: 'Can I trade my design NFT?',
          answer: 'Yes! All design NFTs can be bought and sold on the NFPOP Marketplace. If you sell a winning design\'s NFT, the new owner receives future royalties.'
        },
        {
          id: 'c4',
          question: 'What makes a good design prompt?',
          answer: 'Be creative and specific! Describe themes, costumes, accessories, and colors. Try "A ninja cat with shuriken, wearing a tiny black mask" or "A rainbow unicorn with sparkly mane and cloud accessories".'
        }
      ]
    },
    auctions: {
      icon: '🔨',
      label: 'Auctions',
      faqs: [
        {
          id: 'a1',
          question: 'What is the Auction House?',
          answer: 'The Auction House lets you buy and sell Popper NFTs! List your NFT designs for auction and let the community bid, or bid on NFTs you want to own. Winners receive royalties if the design becomes a product!'
        },
        {
          id: 'a2',
          question: 'How do I start an auction?',
          answer: 'Connect your wallet, go to the Auction page, and click "Start Auction". Select one of your Popper NFTs, set a starting bid price, duration (3-30 days), and minimum bid increment. Your NFT will be held in escrow until the auction ends.'
        },
        {
          id: 'a3',
          question: 'How do I place a bid?',
          answer: 'Find an active auction you like, enter your bid amount (must be higher than current bid plus minimum increment), and click "Place Bid". Your SOL is held in escrow. If outbid, your SOL is automatically refunded.'
        },
        {
          id: 'a4',
          question: 'What is the platform fee?',
          answer: 'A 2.5% platform fee is deducted from the winning bid amount. This supports the Popperverse ecosystem and development.'
        },
        {
          id: 'a5',
          question: 'What is anti-snipe protection?',
          answer: 'If a bid is placed in the last 5 minutes of an auction, the end time is automatically extended by 5 minutes. This prevents last-second sniping and gives everyone a fair chance to bid.'
        },
        {
          id: 'a6',
          question: 'Can I cancel my auction?',
          answer: 'Yes, but only if there are no bids yet. Once someone bids, the auction must complete. Click "Cancel Auction" on your listing to reclaim your NFT.'
        },
        {
          id: 'a7',
          question: 'What happens when an auction ends?',
          answer: 'When an auction ends, the seller, winner, or any community member can click "Finalize Auction" to complete the sale. This transfers the NFT to the highest bidder and sends payment to the seller (minus 2.5% platform fee). Finalization is required to release the escrowed NFT and funds.'
        }
      ]
    }
  };

  return (
    <div className="faq-page">
      <h2>Frequently Asked Questions</h2>
      
      <div className="faq-categories">
        {Object.entries(categories).map(([key, category]) => (
          <button
            key={key}
            className={`category-tab ${activeCategory === key ? 'active' : ''}`}
            onClick={() => setActiveCategory(key)}
          >
            <span className="category-icon">{category.icon}</span>
            <span className="category-label">{category.label}</span>
          </button>
        ))}
      </div>
      
      <div className="faq-container">
        {categories[activeCategory].faqs.map((faq) => (
          <div 
            key={faq.id} 
            className={`faq-item ${expandedItems[faq.id] ? 'expanded' : ''}`}
            onClick={() => toggleItem(faq.id)}
          >
            <div className="faq-header">
              <h4>{faq.question}</h4>
              <span className="faq-toggle">{expandedItems[faq.id] ? '−' : '+'}</span>
            </div>
            <div className={`faq-answer ${expandedItems[faq.id] ? 'show' : ''}`}>
              <p>{faq.answer}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="contact-section">
        <h3>Still have questions?</h3>
        <p>Join our community on Telegram or follow us on X (Twitter) for updates!</p>
        <div className="social-links">
          <a href="https://t.me/POPPERVERSEVERIFY" target="_blank" rel="noopener noreferrer" className="social-btn telegram">
            Telegram
          </a>
          <a href="https://twitter.com/popperverse" target="_blank" rel="noopener noreferrer" className="social-btn twitter">
            𝕏 Twitter
          </a>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
